import { render, staticRenderFns } from "./CuisineList.vue?vue&type=template&id=27d54efc&scoped=true&"
import script from "./CuisineList.vue?vue&type=script&lang=js&"
export * from "./CuisineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d54efc",
  null
  
)

export default component.exports